export default __webpack_public_path__ + "static/media/cross.45ab711a.svg";